import { setupWorker } from 'msw';

export const worker = setupWorker();
